import { AccountType, CardType, MultibankingAccountType } from './enums';
import { ExternalProductType } from './ExternalProductType';

export type ProductType = AccountType | MultibankingAccountType | ExternalProductType | CardType;
export const ProductType = {
    ...AccountType,
    ...MultibankingAccountType,
    ...ExternalProductType,
    ...CardType,
};
